<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2025-03-15 10:23:59
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2026-03-10 09:42:59
 * @FilePath: \vue-hd-ota\src\views\login\Index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="container">
        <div class="line">
            <div class="line_top"></div>
            <div class="line_bottom"></div>
        </div>
        <div class="login_card">
            <div class="login_hd">
                <img src="@/assets/image/logo_black.png" class="login_img" alt="" width="200">
                <div class="login_title">欢迎登录HD-OTA平台</div>
            </div>
            
            <a-form class="login_form" layout="vertical" :model="formState" v-bind="formItemLayout">
                <a-form-item :label="t('login.user_name')" v-bind="validateInfos.user_name">
                    <a-input v-model:value="formState.user_name" :placeholder="t('base.enter')" />
                </a-form-item>
                <a-form-item :label="t('login.password')" v-bind="validateInfos.password">
                    <a-input-password v-model:value="formState.password" :placeholder="t('base.enter')"/>
                </a-form-item>
                <a-form-item :label="t('login.captcha')" v-bind="validateInfos.captcha">
                    <a-input v-model:value="formState.captcha" :placeholder="t('base.enter')" style="width: 150px"/>
                    <!-- <img id="captchaImage" src="http://10.10.144.201:8080/ota/auth/captcha" alt="验证码" width="130" height="35"/> -->
                    <img id="captchaImage" src="" alt="验证码" width="130" height="35" @click="getCaptcha"/>
                    <span class="time">剩余{{ time }}s</span>
                </a-form-item>
                <a-checkbox v-model:checked="rememberPwd" @change="rememberPassword">记住密码</a-checkbox>
                <a-button class="login_btn" type="primary" @click.prevent="login">{{ $t('login.loginBtn') }}</a-button>
            </a-form>
        </div>
    </div>
</template>

<script setup>
    import { ref, reactive, onMounted } from "vue";
    import {useRouter, useRoute} from 'vue-router';
    import { useI18n } from 'vue-i18n';
    import { message, Modal } from 'ant-design-vue';
    import { globalView } from '@/store/global';
    import { LoginApi  } from '@/api/LoginApi.js';
    import { UserApi } from '@/api/UserApi.js';
    import { Form } from 'ant-design-vue';
    import jwt_decode from "jwt-decode";

    const router = useRouter()
    const route = useRoute()
    const {t} = useI18n()
    const i18n = useI18n()

    const useForm = Form.useForm
    const rememberPwd = ref(false)
    const captcha_id = ref('')
    const time = ref(60)
    const formState = reactive({
        user_name:'',
        password:'',
        captcha:'',
    })
    const rulesRef = reactive({
        user_name: [
            {
                required: true,
                message: '用户名不能为空！',
            },
        ],
        password: [
            {
                required: true,
                message: '密码不能为空！',
            },
        ],
        captcha: [
            {
                required: true,
                message: '验证码不能为空！',
            },
        ],
    });

    // 记住密码
    const rememberPassword = (val)=>{
        console.log(val.target.checked,'ll')
        if(formState.user_name == '' || formState.password == ''){
            message.error('用户名及密码不能为空！')
            rememberPwd.value= false
            return 
        }
        if(val.target.checked){
            localStorage.setItem('hd_ota_rememberPwd', JSON.stringify({user_name: formState.user_name, password:formState.password, rememberPwd: true}))
        }else{
            localStorage.removeItem('hd_ota_rememberPwd')
        }
    }

    // 获取验证码
    const getCaptcha = async ()=>{
        let res = await LoginApi.getInstance().getCaptcha()
        if (res.code == 0) {
            captcha_id.value = res.data.captcha_id
            document.getElementById("captchaImage").setAttribute('src',`data:image/png;base64,${res.data.base64}`)
        } else {
            message.error(res.msg);
        }
    }

    // 登录
    const { resetFields, validate, validateInfos } = useForm(formState, rulesRef, {});
    const login = async ()=>{
        validate().then(async () => {
            let param = {
                ...formState,
                captcha_id: captcha_id.value,
            }
            let res = await LoginApi.getInstance().login(param)
            if(res.code == 0){
                let loginUser = jwt_decode(res.access_token)
                // sessionStorage.setItem("loginUser", JSON.stringify(loginUser));
                // sessionStorage.setItem("token", res.access_token);
                localStorage.setItem("hd_ota_loginUser", JSON.stringify(loginUser));
                localStorage.setItem("hd_ota_token", res.access_token);
                router.replace('/Notice/List')
            }else{
                Modal.error({
                    title: '提示',
                    content: res.msg,
                    onOk() {
                        formState.captcha = ''
                        getCaptcha()
                    },
                });
            }
        }).catch(err => {
            console.log('error', err);
        })
    }

    onMounted(()=>{
        getCaptcha()

        const timer =setInterval(()=>{
            console.log(route, 'route', time.value)
            if(time.value == 0){
                if(route.path !== '/Login'){
                    clearInterval(timer)
                    return
                }

                getCaptcha()
                time.value = 60
            }else{
                time.value -= 1
            }
        },1000)

        if(localStorage.getItem('hd_ota_rememberPwd')){
            let data = JSON.parse(localStorage.getItem('hd_ota_rememberPwd'))
            formState.user_name = data.user_name
            formState.password = data.password
            rememberPwd.value = data.rememberPwd
        }
    })
</script>

<style lang="scss" scoped>
.container{
    height: 100vh;
    overflow-y: scroll;

    .line{
        position: absolute;
        top: 50%;
        width: 100%;
        height: 50px;
        transform: skew(0deg, -10deg);

        .line_top{
            width: 400px;
            height: 25px;
            background: #81e9ff;
        }
        .line_bottom{
            width: 100%;
            height: 25px;
            background: #1226aa;
        }
    }

    .login_card{
        position: fixed;
        top:50%;
        left:50%;
        z-index: 2;
        padding: 40px 25px;
        margin-top: -300px;
        margin-left: -300px;
        width: 600px;
        border-radius: 5px;
        box-shadow: 1px 1px 7px -1px #ccc;
        background: #fff;

        .login_hd{
            margin: 10px 0;
            width: 100%;
            text-align: center;

            .login_title{
                margin: 20px 0 40px;
                font-size: 18px;
            }
        }

        .login_form{
            .login_btn{
                margin-top: 20px;
                width: 100%;
                height: 40px;
            }
        }

        .time{
            margin-left: 10px;
            font-size: 14px;
            color: #999;
        }
    }

    #captchaImage{
        margin-top: -5px;
        margin-left: 15px;
        cursor: pointer;
    }
}

</style>